// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__35GBo","table":"Table_table__2hmap","noResult":"Table_noResult__qVBrm"};